import Box from 'components/Box'
import React from 'react'

function LocalPageTemplate({ organization, body }) {
  return (
    <Box modifierClasses='u-mt-150'>
      <div className="formatted-content local-content">
        <h3>{organization}</h3>
        <span dangerouslySetInnerHTML={{ __html: body }} />
      </div>
    </Box>
  )
}

export default LocalPageTemplate
